module.exports = __webpack_public_path__ + "static/media/sign_out.3e9cef30.svg";